<template>
  <div class="MonthlyIO">
    <box :title="$t('search')">
      <div>
        <monthly-date-picker @getDate="getDate" />
      </div>
    </box>

    <box :title="$t('PeriodicIOList')" class="mt-2">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="list.length > 0">
        <v-alert
          class="ma-2"
          text
          dense
          color="teal"
          icon="mdi-comment-alert-outline"
          border="left"
        >
          توجه: سطر های سبز رنگ ورود و خروج های تائید نشده شما می باشند.
        </v-alert>
        <v-alert
          class="ma-2"
          text
          dense
          color="primary lighten-1"
          icon="mdi-comment-alert-outline"
          border="left"
        >
          با کلیک راست کردن روی هر سطر می توانید عملیات ثبت مرخصی، ماموریت،ورود
          و خروج و اضافه کار را انجام دهید
        </v-alert>
        <MonthlyIOListWeb :list="list" class="hidden-sm-and-down" />
        <MonthlyIOListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import MonthlyIOListMob from "../../components/io/MonthlyIO/MonthlyIOListMob.vue";
import MonthlyIOListWeb from "../../components/io/MonthlyIO/MonthlyIOListWeb.vue";
import MonthlyDatePicker from "../../components/widget/MonthlyDatePicker.vue";
import EosUtils from "../../utils/EosUtils";
export default {
  components: { MonthlyIOListWeb, MonthlyIOListMob, MonthlyDatePicker },
  data() {
    return {
      list: [],
      year: "",
      month: "",
      visiblePrint: false,
    };
  },
  methods: {
    getDate(year, month) {
      this.year = year;
      this.month = month;
      this.GetFullPeriodIoInfo(year, month);
    },
    GetFullPeriodIoInfo(year, month) {
      this.list = [];

      const params = new URLSearchParams();
      params.append("periodNumber", month);
      params.append("year", year);

      this.$store.dispatch("GetFullPeriodIoInfo", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success" && result.data) {
          this.list = result.data;
          this.checkVisiblePrint();
        }
      });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var permission = this.$store.state.personel.personelDetail.Permission;
        if (permission[19].toString() == "1") {
          this.visiblePrint = true;
        }
      }
    },
    print() {
      if (this.month && this.year) {
        const params = new URLSearchParams();
        params.append("periodNumber", this.month);
        params.append("year", this.year);

        this.$store
          .dispatch("GetPeriodBeginAndEndDate", { params })
          .then((result) => {
            if (result.type === "success") {
              if (result.data.length > 0) {
                let data = result.data[0];

                var dp = this.$store.state.auth.auth.username;
                let routeData = this.$router.resolve({
                  name: "rpIoInfo",
                  query: { BD: data.BeginDate, ED: data.EndDate, dp: dp },
                });
                window.open(routeData.href, "_blank");
              }
            }
          });
      }
    },
  },
};
</script>

<style>
</style>